<app-modal *ngIf="modalData && modalData.length > 0"></app-modal>
<app-navbar></app-navbar>

<!-- ═══════════════════════════════════════════════════════
     SECTION 1 — NATIVE HERO SLIDER
═══════════════════════════════════════════════════════ -->
<div class="rs-native-hero-slider">
  <div *ngIf="loadingData" class="rs-hero-loading">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="rs-slider-container" *ngIf="!loadingData && slides.length > 0">
    <div 
      class="rs-slide" 
      *ngFor="let slide of slides; let i = index" 
      [class.active]="i === activeSlideIndex"
    >
      <div class="rs-slide-bg" [style.backgroundImage]="'url('+slide.ImageLink+')'"></div>
      <div class="rs-slide-overlay"></div>
      <div class="rs-slide-content">
        <span class="rs-slide-kicker">Welcome</span>
        <h2 class="rs-slide-title">{{MainData?.Name || MainData?.InstituteName || 'Excellence in Education'}}</h2>
        <p class="rs-slide-subtitle">Empowering minds and shaping futures — a community of learning, innovation and discovery dedicated to excellence.</p>
        <a class="rs-slide-btn" routerLink="/notice-board">START EXPLORING <i class="fas fa-arrow-right"></i></a>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <button class="rs-slider-arrow rs-slider-prev" (click)="prevSlide()"><i class="fas fa-chevron-left"></i></button>
    <button class="rs-slider-arrow rs-slider-next" (click)="nextSlide()"><i class="fas fa-chevron-right"></i></button>

    <!-- Pagination Dots -->
    <div class="rs-slider-pagination">
      <span 
        class="rs-slider-dot" 
        *ngFor="let slide of slides; let i = index"
        [class.active]="i === activeSlideIndex"
        (click)="goToSlide(i)"
      ></span>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     NOTICE TICKER — Fixed bottom bar
═══════════════════════════════════════════════════════ -->
<div class="rs-notice-ticker-fixed" *ngIf="All_Notices?.length">
  <div class="container-fluid px-0">
    <div class="d-flex align-items-center" style="height:44px;">
      <span class="ticker-label"><i class="ri-notification-3-fill me-1"></i> Latest Notice</span>
      <div class="ticker-scroll-wrap">
        <marquee behavior="scroll" direction="left"
                 onmouseover="this.stop();" onmouseleave="this.start();"
                 style="color:#fff;font-size:13px;line-height:44px;">
          <ng-container *ngFor="let n of All_Notices">
            <a (click)="onNavigate(n.FileLink)"
               style="color:#fff;text-decoration:none;cursor:pointer;margin-right:70px;">
              <i class="ri-arrow-right-s-line"></i> {{n.EnglishTitle}}
            </a>
          </ng-container>
        </marquee>
      </div>
      <a routerLink="/notice-board" class="ticker-cta">View All <i class="ri-arrow-right-s-line"></i></a>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 2 — WELCOME TITLE (rt-vc-title style1)
     Eikra: White bg, centered title + subtitle
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-welcome-row">
  <div class="container">
    <div class="rt-vc-title style1 text-center">
      <h2>Welcome To <span class="rtin-highlight">{{MainData?.Name || MainData?.InstituteName || 'Our Institution'}}</span></h2>
      <p class="rtin-subtitle">We are dedicated to providing quality education and fostering a community of excellence, innovation, and lifelong learning for all our students and faculty members.</p>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 3 — FEATURE INFO BOXES (rt-info-box layout3)
     Eikra: White bg, circular gold icon, 3 columns
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-infobox-row">
  <div class="container">
    <div class="row">
      <div class="col-sm-4 col-md-4 col-12">
        <a routerLink="/notice-board" class="media rt-info-box layout3 ekra-reveal ekra-up ekra-d0">
          <div class="rtin-icon rounded">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <div class="media-body">
            <h3 class="media-heading">Notice Board</h3>
            <p class="mb0">Stay updated with official notices, circulars and important announcements from our institution.</p>
          </div>
        </a>
      </div>
      <div class="col-sm-4 col-md-4 col-12">
        <a routerLink="/news-and-events" class="media rt-info-box layout3 ekra-reveal ekra-up ekra-d1">
          <div class="rtin-icon rounded">
            <i class="fas fa-chalkboard-teacher"></i>
          </div>
          <div class="media-body">
            <h3 class="media-heading">News &amp; Events</h3>
            <p class="mb0">Explore our latest news, upcoming events, seminars and special institutional activities.</p>
          </div>
        </a>
      </div>
      <div class="col-sm-4 col-md-4 col-12">
        <a routerLink="/imageFolder" class="media rt-info-box layout3 ekra-reveal ekra-up ekra-d2">
          <div class="rtin-icon rounded">
            <i class="fas fa-book-open"></i>
          </div>
          <div class="media-body">
            <h3 class="media-heading">Photo Gallery</h3>
            <p class="mb0">Browse our photo albums — campus life, events, achievements and memorable milestones.</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 4 — ABOUT / FEATURED NOTICES
     Eikra: Dark navy #012148 bg, rt-vc-course-featured style
     We show institution about + latest notices
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-featured-row vc_row-has-fill">
  <div class="container">
    <div class="rt-vc-course-featured">
      <div class="row">
        <!-- Left large panel: About / Institution Info -->
        <div class="col-md-6 col-12 rtin-leftbox ekra-reveal ekra-left">
          <div class="rtin-featured-main">
            <div class="rtin-sec-label">ABOUT US</div>
            <h2 class="rtin-sec-title" *ngIf="MainData">{{MainData?.Name || MainData?.InstituteName}}</h2>
            <div class="rtin-sec-body"
                 *ngIf="HomeContent?.[0]"
                 [innerHTML]="HomeContent[0].DetailsEn | slice:0:500"></div>
            <p class="rtin-sec-body" *ngIf="!HomeContent?.[0]">
              We are committed to academic excellence, character development, and community service — preparing students to lead and excel in a changing world.
            </p>
            <div class="rtin-sec-btns">
              <a routerLink="/administration" class="rdtheme-button-2">MORE ABOUT US</a>
              <a routerLink="/contact" class="rdtheme-button-1">CONTACT US</a>
            </div>
          </div>
        </div>
        <!-- Right: 2×2 notice cards -->
        <div class="col-md-6 col-12 rtin-rightbox ekra-reveal ekra-right">
          <div class="rtin-notice-grid">
            <div class="rtin-notice-card"
                 *ngFor="let item of Notices | slice:0:4; let i=index"
                 (click)="onNavigate(item.FileLink)"
                 style="cursor:pointer;"
                 [class]="'ekra-reveal ekra-up ekra-d'+i">
              <div class="rtin-notice-top">
                <span class="rtin-notice-date-num">{{item.CreatedDate | date:'dd'}}</span>
                <span class="rtin-notice-date-mon">{{item.CreatedDate | date:'MMM yyyy'}}</span>
              </div>
              <h4 class="rtin-notice-title">{{item.EnglishTitle}}</h4>
              <span class="rtin-notice-link">Read More <i class="fas fa-arrow-right"></i></span>
            </div>
            <!-- Placeholder cards when no notices -->
            <ng-container *ngIf="!Notices?.length">
              <div class="rtin-notice-card ekra-reveal ekra-up ekra-d0">
                <div class="rtin-notice-top">
                  <span class="rtin-notice-date-num">01</span>
                  <span class="rtin-notice-date-mon">Jan 2026</span>
                </div>
                <h4 class="rtin-notice-title">Scholarship Facility Available for Meritorious Students</h4>
                <span class="rtin-notice-link">Read More <i class="fas fa-arrow-right"></i></span>
              </div>
              <div class="rtin-notice-card ekra-reveal ekra-up ekra-d1">
                <div class="rtin-notice-top">
                  <span class="rtin-notice-date-num">15</span>
                  <span class="rtin-notice-date-mon">Feb 2026</span>
                </div>
                <h4 class="rtin-notice-title">New Academic Session Admission Notice 2026</h4>
                <span class="rtin-notice-link">Read More <i class="fas fa-arrow-right"></i></span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 5 — LEADERSHIP (Modern dark redesign)
     Dark navy + dot pattern + circular photos + spin ring
═══════════════════════════════════════════════════════ -->
<section class="rs-leadership-section" *ngIf="GBMessageShown?.length">
  <!-- Ambient glow blobs -->
  <div class="rs-ldr-glow rs-ldr-glow-1"></div>
  <div class="rs-ldr-glow rs-ldr-glow-2"></div>

  <div class="container rs-ldr-container">

    <!-- Section header -->
    <div class="rs-ldr-header text-center ekra-reveal ekra-up">
      <span class="rs-ldr-eyebrow">Meet Our Team</span>
      <h2 class="rs-ldr-title">Our Skilled <span>Leadership</span></h2>
      <p class="rs-ldr-subtitle">Dedicated leaders committed to academic excellence and shaping the future of our institution.</p>
    </div>

    <!-- Leader cards -->
    <div class="rs-ldr-grid">
      <div *ngFor="let item of GBMessageShown | slice:0:8; let i=index"
           [class]="'rs-ldr-card ekra-reveal ekra-zoom ekra-d'+(i%4)">

        <!-- Circular photo with animated gold ring -->
        <div class="rs-ldr-photo-frame">
          <div class="rs-ldr-ring-outer"></div>
          <div class="rs-ldr-ring-inner"></div>
          <div class="rs-ldr-photo">
            <a [routerLink]="getMessageHref(item.GBDesignationName)">
              <img [src]="item.GBImagePath" [alt]="item.GBName"
                   onerror="this.src='assets/img/rs-shapes/logo-red.webp'">
            </a>
          </div>
        </div>

        <!-- Info -->
        <div class="rs-ldr-info">
          <h3 class="rs-ldr-name">
            <a [routerLink]="getMessageHref(item.GBDesignationName)">{{item.GBName}}</a>
          </h3>
          <span class="rs-ldr-role">{{item.GBDesignationName}}</span>
          <!-- Social icons — slide up on hover -->
          <ul class="rs-ldr-social">
            <li><a [routerLink]="getMessageHref(item.GBDesignationName)" title="Message"><i class="fas fa-envelope"></i></a></li>
            <li><a [routerLink]="getMessageHref(item.GBDesignationName)" title="Profile"><i class="fas fa-user"></i></a></li>
            <li><a routerLink="/administration" title="About"><i class="fas fa-info-circle"></i></a></li>
          </ul>
        </div>

      </div>
    </div>

    <!-- View All button -->
    <div class="text-center rs-ldr-footer ekra-reveal ekra-up">
      <a routerLink="/administration" class="rs-ldr-btn">
        View All Leadership <i class="fas fa-long-arrow-alt-right"></i>
      </a>
    </div>

  </div>
</section>

<!-- ═══════════════════════════════════════════════════════
     SECTION 6 — VIDEO SECTION (rt-vc-video rt-dark)
     Eikra: Background image, centered single video item
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-video-row vc_row-has-fill"
     *ngIf="VideoAlbumShown?.length"
     [style.backgroundImage]="'url(' + (VideoAlbumShown[0].CoverImage || VideoAlbumShown[0].ThumbnailUrl || 'assets/img/rs-shapes/graduation-doc-shape.webp') + ')'">
  <div class="container">
    <div class="rt-vc-video rt-dark">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-12">
          <div class="rtin-item text-center">
            <h2 class="rtin-title">Watch Campus Life Video Tour</h2>
            <p class="rtin-content">Explore our campus, events, and special moments through our official video albums. Get a glimpse of the vibrant academic life at our institution.</p>
            <a class="rtin-btn rt-video-play"
               [routerLink]="['/videoFolder', VideoAlbumShown[0].id || VideoAlbumShown[0].Id]">
              <i class="fas fa-play"></i>
            </a>
            <div class="rtin-video-meta">
              <span>{{VideoAlbumShown[0].name || VideoAlbumShown[0].Name || VideoAlbumShown[0].AlbumName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 7 — LATEST POSTS + EVENTS (rt-vc-posts + rt-vc-event)
     Eikra: #f5f5f5 bg, 2-column split
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-posts-events-row vc_row-has-fill">
  <div class="container">
    <div class="row">

      <!-- Left: Latest Posts (rt-vc-posts) -->
      <div class="col-sm-6 col-12 ekra-reveal ekra-left">
        <div class="rt-vc-posts">
          <h2 class="rt-vc-title-left">Latest Posts</h2>
          <div class="rtin-item">
            <ng-container *ngIf="foundnews?.length; else noNews">
              <div class="media media-list"
                   *ngFor="let item of foundnews | slice:0:3"
                   [routerLink]="['/news-and-events', $any(item).Id]"
                   style="cursor:pointer;">
                <div class="media-left rtin-img">
                  <a [routerLink]="['/news-and-events', $any(item).Id]">
                    <img [src]="$any(item).ShowAttachments?.[0]?.FilePath || $any(item).ImagePath || 'assets/img/rs-shapes/logo-red.webp'"
                         [alt]="$any(item).TitleEn"
                         onerror="this.src='assets/img/rs-shapes/logo-red.webp'">
                  </a>
                </div>
                <div class="media-body rtin-content-area">
                  <h3><a [routerLink]="['/news-and-events', $any(item).Id]">{{$any(item).TitleEn}}</a></h3>
                  <div class="rtin-date">{{($any(item).CurrentDate || $any(item).CreatedDate) | date:'MMMM dd, yyyy'}}</div>
                  <p class="rtin-content">{{$any(item).DetailsEn | slice:0:80}}...</p>
                </div>
              </div>
            </ng-container>
            <ng-template #noNews>
              <div class="media media-list">
                <div class="media-left rtin-img">
                  <img src="assets/img/rs-shapes/logo-red.webp" alt="News">
                </div>
                <div class="media-body rtin-content-area">
                  <h3><a routerLink="/news-and-events">No news available at this time</a></h3>
                  <div class="rtin-date">—</div>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="rtin-btn">
            <a routerLink="/news-and-events" class="rdtheme-button-6">VIEW ALL</a>
          </div>
        </div>
      </div>

      <!-- Right: Notice Board (rt-vc-event style) -->
      <div class="col-sm-6 col-12 ekra-reveal ekra-right">
        <div class="rt-vc-event rt-event-block-wrapper">
          <h2 class="rt-vc-title-left">Notice Board</h2>
          <ng-container *ngIf="Notices?.length; else noNotices">
            <div class="media rtin-item"
                 *ngFor="let item of Notices | slice:0:3"
                 (click)="onNavigate(item.FileLink)"
                 style="cursor:pointer;">
              <div class="media-left rtin-calender-holder">
                <div class="rtin-calender">
                  <h3>{{item.CreatedDate | date:'dd'}}<p>{{item.CreatedDate | date:'MMM'}}</p><span>{{item.CreatedDate | date:'yyyy'}}</span></h3>
                </div>
              </div>
              <div class="media-body rtin-right">
                <h3><a (click)="onNavigate(item.FileLink)" style="cursor:pointer;">{{item.EnglishTitle}}</a></h3>
                <p class="rtin-content">{{item.BanglaTitle || 'Click to view attachment'}}</p>
                <ul>
                  <li class="rtin-time"><i class="fas fa-clock"></i>
                    <span class="time-range">{{item.CreatedDate | date:'hh:mm a'}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
          <ng-template #noNotices>
            <div class="media rtin-item">
              <div class="media-left rtin-calender-holder">
                <div class="rtin-calender">
                  <h3>01<p>Jan</p><span>2026</span></h3>
                </div>
              </div>
              <div class="media-body rtin-right">
                <h3><a routerLink="/notice-board">No notices available at this time</a></h3>
              </div>
            </div>
          </ng-template>
          <div class="rtin-btn">
            <a routerLink="/notice-board" class="rdtheme-button-6">VIEW ALL</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 8 — COUNTER (rt-vc-counter, bg image)
     Eikra: Parallax image bg, 4 stat counters
═══════════════════════════════════════════════════════ -->
<!-- ═══ SECTION 8 — VISITOR COUNTER (glassmorphism + 3D) ═══ -->
<section class="rs-counter-section">

  <!-- Animated glowing orbs in background -->
  <div class="rs-counter-bg" aria-hidden="true">
    <div class="rs-orb rs-orb-1"></div>
    <div class="rs-orb rs-orb-2"></div>
    <div class="rs-orb rs-orb-3"></div>
    <div class="rs-orb rs-orb-4"></div>
  </div>

  <!-- Subtle grid overlay -->
  <div class="rs-counter-grid-lines" aria-hidden="true"></div>

  <div class="container">

    <!-- Section eyebrow -->
    <div class="rs-counter-head wow fadeInDown" data-wow-delay="0.1s" data-wow-duration="0.7s">
      <span class="rs-counter-eyebrow">
        <i class="fas fa-chart-bar"></i>&nbsp; Live Statistics
      </span>
      <h2 class="rs-counter-title">Our Growing Community</h2>
    </div>

    <!-- Four stat cards -->
    <div class="rs-stat-grid">

      <div class="rs-stat-card wow fadeInUp" data-wow-delay="0.15s" data-wow-duration="0.7s">
        <div class="rs-stat-glow"></div>
        <div class="rs-stat-icon"><i class="fas fa-eye"></i></div>
        <div class="rs-stat-number rs-count">
          {{displayVisitorStats.today | number}}
        </div>
        <div class="rs-stat-bar"></div>
        <div class="rs-stat-label">Today's Visitors</div>
      </div>

      <div class="rs-stat-card wow fadeInUp" data-wow-delay="0.25s" data-wow-duration="0.7s">
        <div class="rs-stat-glow"></div>
        <div class="rs-stat-icon"><i class="fas fa-calendar-alt"></i></div>
        <div class="rs-stat-number rs-count">
          {{displayVisitorStats.thisMonth | number}}
        </div>
        <div class="rs-stat-bar"></div>
        <div class="rs-stat-label">Monthly Visitors</div>
      </div>

      <div class="rs-stat-card wow fadeInUp" data-wow-delay="0.35s" data-wow-duration="0.7s">
        <div class="rs-stat-glow"></div>
        <div class="rs-stat-icon"><i class="fas fa-chart-line"></i></div>
        <div class="rs-stat-number rs-count">
          {{displayVisitorStats.thisYear | number}}
        </div>
        <div class="rs-stat-bar"></div>
        <div class="rs-stat-label">Yearly Visitors</div>
      </div>

      <div class="rs-stat-card rs-stat-card--highlight wow fadeInUp" data-wow-delay="0.45s" data-wow-duration="0.7s">
        <div class="rs-stat-glow rs-stat-glow--gold"></div>
        <div class="rs-stat-icon rs-stat-icon--gold"><i class="fas fa-users"></i></div>
        <div class="rs-stat-number rs-count">
          {{displayVisitorStats.total | number}}
        </div>
        <div class="rs-stat-bar rs-stat-bar--gold"></div>
        <div class="rs-stat-label">Total Visitors</div>
      </div>

    </div>
  </div>
</section>

<!-- ═══════════════════════════════════════════════════════
     SECTION 9 — PHOTO GALLERY
     Redesigned: header with View All + 9-album grid + gold hover
═══════════════════════════════════════════════════════ -->
<section class="rs-gallery-section" *ngIf="ImageAlbumShown?.length">
  <div class="container">

    <!-- Section header: title left, View All right -->
    <div class="rs-gallery-head clearfix">
      <div class="rs-gallery-title-wrap ekra-reveal ekra-left">
        <span class="rs-gallery-eyebrow">Our Campus Life</span>
        <h2 class="rs-gallery-main-title">Photo <span>Gallery</span></h2>
      </div>
      <a routerLink="/imageFolder" class="rs-gallery-all-btn ekra-reveal ekra-right">
        <i class="fas fa-th-large"></i> View All Albums
      </a>
    </div>

    <!-- Gallery grid — 9 albums, 3 columns -->
    <div class="rs-gallery-grid">
      <a *ngFor="let album of ImageAlbumShown | slice:0:9; let i=index"
         [routerLink]="['/imageFolder', album.id || album.Id]"
         [class]="'rs-gallery-card ekra-reveal ekra-zoom ekra-d'+(i%3)">

        <!-- Thumbnail -->
        <div class="rs-gallery-thumb">
          <img *ngIf="album.CoverImage || album.ThumbnailUrl"
               [src]="album.CoverImage || album.ThumbnailUrl"
               [alt]="album.name || album.Name"
               loading="lazy">
          <div *ngIf="!album.CoverImage && !album.ThumbnailUrl"
               class="rs-gallery-placeholder" [ngClass]="'rs-gp-'+i">
            <i class="fas fa-camera"></i>
          </div>
        </div>

        <!-- Always-visible caption strip -->
        <div class="rs-gallery-caption">
          <h4>{{album.name || album.Name}}</h4>
        </div>

        <!-- Hover overlay (gold) -->
        <div class="rs-gallery-hover">
          <span class="rs-gallery-hover-icon"><i class="fas fa-eye"></i></span>
          <h4 class="rs-gallery-hover-title">{{album.name || album.Name}}</h4>
          <span class="rs-gallery-hover-cta">View Album <i class="fas fa-arrow-right"></i></span>
        </div>

      </a>
    </div>

  </div>
</section>

<!-- ═══════════════════════════════════════════════════════
     SECTION 10 — ACHIEVEMENTS (dark navy, award cards)
═══════════════════════════════════════════════════════ -->
<div class="vc_row wpb_row rs-achievements-row vc_row-has-fill"
     *ngIf="foundAchivements?.length">
  <div class="container">
    <div class="rt-vc-title style1 text-center" style="margin-bottom:40px;">
      <h2 style="color:#fff;">Our Achievements</h2>
      <p class="rtin-subtitle" style="color:rgba(255,255,255,.65);">Celebrating the milestones and accomplishments that define our institution's legacy of excellence.</p>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12"
           *ngFor="let item of foundAchivements | slice:0:4; let i=index">
        <div [class]="'rtin-achievement-card ekra-reveal ekra-up ekra-d'+i"
             [routerLink]="['/achievements', $any(item).Id]" style="cursor:pointer;">
          <div class="rtin-ach-img" *ngIf="$any(item).ShowAttachments?.[0]?.FilePath || $any(item).ImagePath">
            <img [src]="$any(item).ShowAttachments?.[0]?.FilePath || $any(item).ImagePath"
                 [alt]="$any(item).TitleEn">
            <div class="rtin-ach-overlay"><i class="fas fa-award"></i></div>
          </div>
          <div class="rtin-ach-no-img" *ngIf="!$any(item).ShowAttachments?.[0]?.FilePath && !$any(item).ImagePath">
            <i class="fas fa-trophy"></i>
          </div>
          <div class="rtin-ach-body">
            <div class="rtin-ach-date">
              <i class="fas fa-calendar-alt"></i>
              {{($any(item).CurrentDate || $any(item).CreatedDate) | date:'MMMM yyyy'}}
            </div>
            <h4>{{$any(item).TitleEn}}</h4>
            <span class="rtin-ach-link">Read More <i class="fas fa-arrow-right"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" style="margin-top:40px;">
      <a routerLink="/achievements" class="rdtheme-button-7">VIEW ALL ACHIEVEMENTS</a>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════
     SECTION 11 — VIDEO GALLERY
     Grid of video albums with play overlay
═══════════════════════════════════════════════════════ -->
<section class="rs-video-gallery-section" *ngIf="VideoAlbumShown?.length">
  <div class="container">

    <!-- Section header -->
    <div class="rs-vg-head clearfix">
      <div class="rs-vg-title-wrap ekra-reveal ekra-left">
        <span class="rs-vg-eyebrow">Watch &amp; Discover</span>
        <h2 class="rs-vg-main-title">Video <span>Gallery</span></h2>
      </div>
      <a routerLink="/videoFolder" class="rs-vg-all-btn ekra-reveal ekra-right">
        <i class="fas fa-play-circle"></i> View All Videos
      </a>
    </div>

    <!-- Video album grid -->
    <div class="rs-vg-grid">
      <a *ngFor="let album of VideoAlbumShown; let i=index"
         [routerLink]="['/videoFolder', album.id || album.Id]"
         [class]="'rs-vg-card ekra-reveal ekra-zoom ekra-d'+(i%3)">

        <!-- Thumbnail -->
        <div class="rs-vg-thumb">
          <img *ngIf="album.CoverImage || album.ThumbnailUrl"
               [src]="album.CoverImage || album.ThumbnailUrl"
               [alt]="album.name || album.Name || album.AlbumName"
               loading="lazy">
          <div *ngIf="!album.CoverImage && !album.ThumbnailUrl"
               class="rs-vg-placeholder" [ngClass]="'rs-vgp-'+i">
            <i class="fas fa-film"></i>
          </div>
        </div>

        <!-- Centered play button (always visible) -->
        <div class="rs-vg-play-wrap">
          <span class="rs-vg-play-btn"><i class="fas fa-play"></i></span>
        </div>

        <!-- Bottom caption -->
        <div class="rs-vg-caption">
          <h4>{{album.name || album.Name || album.AlbumName}}</h4>
          <span class="rs-vg-watch-label"><i class="fas fa-video"></i> Watch Now</span>
        </div>

        <!-- Hover overlay -->
        <div class="rs-vg-hover-overlay"></div>

      </a>
    </div>

  </div>
</section>

<!-- spacer so fixed bottom ticker doesn't cover content -->
<div class="notice-ticker-spacer" *ngIf="All_Notices?.length"></div>
